import { createBlueprint as r } from "@made-people/blueprint";
const e = r({
  slots: {
    wrapper: "transform inline-block transition-all whitespace-nowrap w-fit"
  },
  variants: {
    color: {
      primary: {
        wrapper: "bg-primary text-primary-contrast"
      },
      secondary: {
        wrapper: "bg-secondary text-secondary-contrast"
      },
      tertiary: {
        wrapper: "bg-tertiary text-tertiary-contrast"
      },
      black: {
        wrapper: "bg-black text-black-contrast"
      },
      white: {
        wrapper: "bg-white text-white-contrast"
      },
      grey: {
        wrapper: "bg-grey text-grey-contrast"
      },
      // Deprecated
      red: {
        wrapper: "bg-red-badge-bg text-red-badge-text"
      },
      lilac: { wrapper: "" },
      // stronger
      "lilac-dark": { wrapper: "" },
      // stronger
      mint: { wrapper: "" },
      // stronger
      "mint-dark": { wrapper: "" },
      // stronger
      archive: { wrapper: "" }
    },
    size: {
      sm: {
        wrapper: "py-1 px-1.5 text-label-sm font-medium font-primary line-height-1"
      },
      md: {
        wrapper: "py-1 px-2 text-label-md font-medium font-primary"
      },
      lg: {
        wrapper: "py-2 px-2 text-label-md font-medium font-primary"
      }
    }
  }
});
export {
  e as badgeBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
